import * as React from "react";
import { SVGAttributes } from "react";

export const TestLeftIcon = React.memo(
  ({
    size = 24,
    color = "#4E5361",
    ...props
  }: SVGAttributes<SVGElement> & {
    size?: number,
  }) => {
    return (
      <svg width={size} height={size} fill="none" {...props}>
        <g filter="url(#test-left_svg__a)">
          <path
            d="M103 67.579c0-6.887 5.583-12.47 12.469-12.47h177.062c6.886 0 12.469 5.583 12.469 12.47V264.59c0 6.886-5.583 12.469-12.469 12.469H115.469c-6.886 0-12.469-5.583-12.469-12.469V67.579z"
            fill="#FBFBFB"
          />
        </g>
        <g filter="url(#test-left_svg__b)">
          <path
            d="M76 60.751c0-7.363 5.97-13.333 13.333-13.333h189.334c7.363 0 13.333 5.97 13.333 13.333v210.667c0 7.364-5.97 13.333-13.333 13.333H89.333c-7.364 0-13.333-5.969-13.333-13.333V60.751z"
            fill="#FBFBFB"
          />
        </g>
        <g filter="url(#test-left_svg__c)">
          <path
            d="M31 46.178C31 37.795 37.795 31 46.178 31h215.529c8.382 0 15.178 6.795 15.178 15.178v239.814c0 8.382-6.796 15.178-15.178 15.178H46.178c-8.383 0-15.178-6.796-15.178-15.178V46.178z"
            fill="#FBFBFB"
          />
        </g>
        <circle
          cx={94.369}
          cy={80.709}
          r={12.901}
          stroke="#CECECE"
          strokeWidth={2.277}
        />
        <path
          d="M107.27 80.709a12.9 12.9 0 01-17.92 11.885"
          stroke="#9D52FC"
          strokeWidth={2.277}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M31 65.91h33.392v235.259H46.178c-8.383 0-15.178-6.795-15.178-15.178V65.909z"
          fill="#A7A7A7"
        />
        <path
          d="M53.952 84.66h-.001l-5.486-5.486a1.23 1.23 0 00-.875-.363c-.331 0-.642.13-.876.363l-5.483 5.483-.005.006a1.24 1.24 0 00.862 2.11h.218v4.038c0 .799.65 1.449 1.45 1.449h2.146a.394.394 0 00.394-.394V88.7a.66.66 0 01.66-.661h1.267a.66.66 0 01.66.66v3.166c0 .217.177.394.395.394h2.146a1.45 1.45 0 001.449-1.45v-4.036h.203a1.24 1.24 0 00.876-2.113zm-.558 1.194a.448.448 0 01-.318.132h-.597a.394.394 0 00-.394.394v4.43a.663.663 0 01-.661.662h-1.752V88.7c0-.8-.65-1.45-1.45-1.45h-1.265c-.8 0-1.45.65-1.45 1.45v2.77h-1.752a.662.662 0 01-.66-.66v-4.43a.394.394 0 00-.395-.394h-.586l-.019-.001a.45.45 0 01-.31-.768l5.487-5.486a.447.447 0 01.636 0l5.484 5.485.003.002a.451.451 0 01-.001.636zm1.132 42.378h-13.66v.455h13.66v-.455z"
          fill="#fff"
          fillOpacity={0.7}
        />
        <path
          d="M40.865 128.182h-.05v.555h13.76v-.555h-13.71z"
          stroke="#fff"
          strokeOpacity={0.7}
          strokeWidth={0.1}
        />
        <path
          d="M41.776 127.776h2.277a.228.228 0 00.228-.228v-4.098a.228.228 0 00-.228-.228h-2.277a.228.228 0 00-.227.228v4.098c0 .126.102.228.227.228zm.228-4.098h1.821v3.642h-1.821v-3.642z"
          fill="#fff"
          fillOpacity={0.7}
        />
        <path
          d="M41.776 127.826h2.277a.278.278 0 00.278-.278v-4.098a.278.278 0 00-.278-.278h-2.277a.278.278 0 00-.277.278v4.098c0 .154.124.278.277.278zm.278-4.098h1.721v3.542h-1.721v-3.542z"
          stroke="#fff"
          strokeOpacity={0.7}
          strokeWidth={0.1}
        />
        <path
          d="M48.151 127.776h2.277a.228.228 0 00.228-.228v-6.83a.228.228 0 00-.228-.227h-2.277a.228.228 0 00-.227.227v6.83c0 .126.102.228.227.228zm.228-6.83H50.2v6.375h-1.82v-6.375z"
          fill="#fff"
          fillOpacity={0.7}
        />
        <path
          d="M48.151 127.826h2.277a.278.278 0 00.278-.278v-6.83a.277.277 0 00-.278-.277h-2.277a.277.277 0 00-.277.277v6.83c0 .154.124.278.277.278zm.278-6.83h1.721v6.275h-1.72v-6.275z"
          stroke="#fff"
          strokeOpacity={0.7}
          strokeWidth={0.1}
        />
        <path
          d="M44.963 127.776h2.277a.228.228 0 00.227-.228v-9.562a.228.228 0 00-.227-.228h-2.277a.228.228 0 00-.228.228v9.562c0 .126.102.228.228.228zm.228-9.562h1.821v9.106h-1.821v-9.106z"
          fill="#fff"
          fillOpacity={0.7}
        />
        <path
          d="M44.963 127.826h2.277a.278.278 0 00.277-.278v-9.562a.278.278 0 00-.277-.278h-2.277a.278.278 0 00-.278.278v9.562c0 .153.125.278.278.278zm.278-9.562h1.721v9.006h-1.721v-9.006z"
          stroke="#fff"
          strokeOpacity={0.7}
          strokeWidth={0.1}
        />
        <path
          d="M51.338 127.776h2.277a.228.228 0 00.227-.228v-12.294a.228.228 0 00-.227-.228h-2.277a.228.228 0 00-.228.228v12.294c0 .126.102.228.228.228zm.228-12.294h1.821v11.839h-1.821v-11.839z"
          fill="#fff"
          fillOpacity={0.7}
        />
        <path
          d="M51.338 127.826h2.277a.278.278 0 00.277-.278v-12.294a.278.278 0 00-.277-.278h-2.277a.278.278 0 00-.278.278v12.294c0 .154.125.278.278.278zm.278-12.294h1.721v11.739h-1.721v-11.739z"
          stroke="#fff"
          strokeOpacity={0.7}
          strokeWidth={0.1}
        />
        <path
          d="M51.06 194.475v-1.203a3.904 3.904 0 00-2.766-3.729v-.545c0-.623-.508-1.131-1.131-1.131-.624 0-1.131.508-1.131 1.131v.545a3.904 3.904 0 00-2.766 3.729v1.203a5.922 5.922 0 01-1.654 4.117.377.377 0 00.272.638h3.431a1.889 1.889 0 001.848 1.508c.91 0 1.672-.649 1.847-1.508h3.432a.377.377 0 00.272-.638 5.922 5.922 0 01-1.655-4.117zm-4.274-5.477a.378.378 0 01.754 0v.396a3.918 3.918 0 00-.754 0v-.396zm.377 10.986c-.492 0-.91-.315-1.067-.754h2.133a1.133 1.133 0 01-1.066.754zm-4.467-1.508a6.669 6.669 0 001.325-4.001v-1.203a3.145 3.145 0 013.142-3.142 3.145 3.145 0 013.142 3.142v1.203c0 1.456.465 2.85 1.324 4.001h-8.933zm9.368-5.204a.377.377 0 00.754 0 5.621 5.621 0 00-1.656-4 .378.378 0 00-.534.534 4.867 4.867 0 011.436 3.466zm-10.181.377a.377.377 0 00.377-.377c0-1.31.51-2.541 1.436-3.466a.378.378 0 00-.533-.534 5.621 5.621 0 00-1.657 4c0 .208.169.377.377.377zm12.548-37.295l-1.526-3.968a1.456 1.456 0 00-1.882-.834l-.032.013-7.627 3.161a1.449 1.449 0 00-.805 1.854l.21.56h-.481a1.423 1.423 0 00-1.422 1.422v5.117a1.424 1.424 0 001.422 1.422h9.666a1.423 1.423 0 001.422-1.422v-5.117a1.39 1.39 0 00-.02-.231l.263-.107a1.46 1.46 0 00.812-1.87zm-12.143 1.241h9.666c.51.001.932.4.961.91H41.327c.03-.51.45-.909.96-.91zm2.286-1.37l1.52-.761.313.782-1.52.76-.313-.781zm8.347 7.454a.968.968 0 01-.967.967h-9.666a.968.968 0 01-.967-.967v-2.9h11.6v2.9zm0-3.355h-11.6v-1.364h11.6v1.364zm.528-2.52l-.238.096a1.422 1.422 0 00-1.257-.76h-6.318l1.161-.581a.227.227 0 00.11-.288l-.482-1.205a.228.228 0 00-.296-.127l-.017.008-1.929.965a.228.228 0 00-.11.288l.377.94h-1.196l-.269-.718a.996.996 0 01.553-1.274l7.627-3.161a.999.999 0 011.315.564l1.526 3.968a1.003 1.003 0 01-.557 1.285z"
          fill="#fff"
          fillOpacity={0.7}
        />
        <path
          d="M51.954 157.09c.531.001 1.02.287 1.28.747l.196-.079a.954.954 0 00.53-1.221l-2.006.553zm0 0h-6.106m6.106 0h-6.106m0 0l.972-.486-.023-.045-.95.531zm.262-2.197a.277.277 0 01.36.154l-.36-.154zm0 0l-.02.009.02-.009zm5.844 9.703a.918.918 0 00.917-.917v-2.85h-11.5v2.85m10.583.917l-10.633-.917h.05m10.583.917h-9.666m9.666 0h-9.666m-.917-.917c0 .506.41.916.917.917m-.917-.917l.917.917m12.19-8.259l-1.526-3.968a1.506 1.506 0 00-1.947-.864l-.034.014-7.626 3.161a1.5 1.5 0 00-.833 1.918l.185.492h-.41a1.473 1.473 0 00-1.47 1.471v5.118c0 .812.658 1.471 1.47 1.472h9.667a1.474 1.474 0 001.472-1.472v-5.118c0-.066-.006-.132-.015-.198l.227-.092a1.511 1.511 0 00.84-1.934zm-2.044-3.768l1.526 3.968-7.87-1.635-1.93.965a.277.277 0 00-.133.351l.349.872h-1.087l-.257-.686a.946.946 0 01.525-1.21l7.627-3.161-.02-.046.02.046a.95.95 0 011.24.513l.01.023zm-10.146 5.076h9.666a.915.915 0 01.907.81H41.38a.915.915 0 01.907-.81zm2.625-.708l-.276-.688 1.43-.715.276.688-1.43.715zm7.958 3.337h-11.5v-1.264h11.5v1.264z"
          stroke="#fff"
          strokeOpacity={0.7}
          strokeWidth={0.1}
        />
        <path
          d="M49.047 164.006c.424.246.947.246 1.37 0a1.365 1.365 0 100-2.36 1.364 1.364 0 10-1.37 2.36zm1.751-2.034a.89.89 0 01.302-.056.91.91 0 010 1.82.89.89 0 01-.302-.056 1.359 1.359 0 000-1.708zm-.38.259a.893.893 0 010 1.191.893.893 0 010-1.191zm-.683-.315c.104.001.206.02.303.056a1.358 1.358 0 000 1.708.891.891 0 01-.303.056.91.91 0 110-1.82z"
          fill="#fff"
          fillOpacity={0.7}
        />
        <path
          d="M51.1 161.411a1.416 1.416 0 00-.682.178 1.415 1.415 0 00-1.396 2.46c.43.251.961.255 1.396.015a1.415 1.415 0 10.682-2.653zm0 0v.05-.05zm0 2.275a.856.856 0 01-.22-.031 1.41 1.41 0 000-1.657.857.857 0 01.22-.032.86.86 0 010 1.72zm-.682-.342a.843.843 0 010-1.035.843.843 0 010 1.035zm-1.542-.518a.86.86 0 01.86-.86.857.857 0 01.219.032 1.41 1.41 0 000 1.657.86.86 0 01-1.079-.829z"
          stroke="#fff"
          strokeOpacity={0.7}
          strokeWidth={0.1}
        />
        <path
          d="M50.46 156.148l.185.416 2.17-.965-.185-.415-2.17.964z"
          fill="#fff"
          fillOpacity={0.7}
        />
        <path
          d="M50.6 156.584l.02.046.045-.02 2.17-.965.046-.02-.02-.046-.185-.416-.02-.045-.047.02-2.17.964-.045.021.02.045.185.416z"
          stroke="#fff"
          strokeOpacity={0.7}
          strokeWidth={0.1}
        />
        <path
          d="M52.145 154.221l-3.134 1.446.19.413 3.135-1.447-.19-.412z"
          fill="#fff"
          fillOpacity={0.7}
        />
        <path
          d="M48.99 155.622l-.045.021.021.045.19.413.022.045.045-.021 3.134-1.446.045-.021-.02-.046-.191-.412-.021-.046-.045.021-3.135 1.447z"
          stroke="#fff"
          strokeOpacity={0.7}
          strokeWidth={0.1}
        />
        <rect
          x={87.159}
          y={153.942}
          width={220.841}
          height={30.356}
          rx={7.589}
          fill="#fff"
        />
        <circle cx={106.511} cy={168.741} r={11.004} fill="#F1F1F1" />
        <path
          d="M101.159 173.737l4.262-9.562h2.185l4.276 9.562h-2.322l-3.497-8.442h.874l-3.511 8.442h-2.267zm2.131-2.049l.587-1.68h4.918l.601 1.68h-6.106z"
          fill="#9B53C8"
        />
        <rect
          x={128.14}
          y={160.772}
          width={169.995}
          height={3.036}
          rx={1.518}
          fill="#C7C7C7"
        />
        <rect
          x={128.14}
          y={167.603}
          width={169.995}
          height={3.036}
          rx={1.518}
          fill="#C7C7C7"
        />
        <rect
          x={128.14}
          y={174.433}
          width={169.995}
          height={3.036}
          rx={1.518}
          fill="#C7C7C7"
        />
        <rect
          x={87.159}
          y={203.271}
          width={220.841}
          height={30.356}
          rx={7.589}
          fill="#9B53C8"
        />
        <circle cx={106.511} cy={218.07} r={11.004} fill="#A58AF0" />
        <path
          d="M109.443 218.093c.547.173.975.465 1.285.875.309.4.464.897.464 1.489 0 .838-.328 1.484-.984 1.939-.646.447-1.593.67-2.841.67h-4.945v-9.562h4.672c1.166 0 2.058.223 2.677.669.629.446.943 1.052.943 1.817 0 .464-.114.879-.342 1.243a2.288 2.288 0 01-.929.86zm-4.822-2.923v2.254h2.2c.546 0 .96-.096 1.243-.287.282-.191.423-.473.423-.847 0-.373-.141-.651-.423-.833-.283-.191-.697-.287-1.243-.287h-2.2zm2.582 6.229c.583 0 1.02-.095 1.312-.287.3-.191.45-.487.45-.888 0-.792-.587-1.188-1.762-1.188h-2.582v2.363h2.582z"
          fill="#fff"
        />
        <rect
          x={128.14}
          y={210.102}
          width={169.995}
          height={3.036}
          rx={1.518}
          fill="#fff"
        />
        <rect
          x={128.14}
          y={216.932}
          width={169.995}
          height={3.036}
          rx={1.518}
          fill="#fff"
        />
        <rect
          x={128.14}
          y={223.762}
          width={169.995}
          height={3.036}
          rx={1.518}
          fill="#fff"
        />
        <rect
          x={87.159}
          y={252.601}
          width={220.841}
          height={30.356}
          rx={7.589}
          fill="#fff"
        />
        <circle cx={106.511} cy={267.399} r={11.004} fill="#F1F1F1" />
        <path
          d="M107.212 272.558a5.875 5.875 0 01-2.063-.355 4.863 4.863 0 01-2.732-2.609 5.02 5.02 0 01-.382-1.981c0-.719.127-1.379.382-1.98a4.863 4.863 0 011.093-1.571 4.902 4.902 0 011.653-1.025 5.608 5.608 0 012.062-.369c.829 0 1.576.146 2.241.438a4.311 4.311 0 011.694 1.256l-1.421 1.312a3.246 3.246 0 00-1.093-.834 3.009 3.009 0 00-1.311-.286 3.35 3.35 0 00-1.23.218 2.805 2.805 0 00-.97.628 2.975 2.975 0 00-.642.97 3.411 3.411 0 00-.218 1.243c0 .456.073.87.218 1.244.155.373.369.696.642.969.274.274.597.483.97.629.374.145.783.218 1.23.218.473 0 .91-.091 1.311-.273a3.335 3.335 0 001.093-.86l1.421 1.311a4.433 4.433 0 01-1.694 1.27c-.665.292-1.416.437-2.254.437z"
          fill="#9B53C8"
        />
        <rect
          x={128.14}
          y={259.431}
          width={169.995}
          height={3.036}
          rx={1.518}
          fill="#C7C7C7"
        />
        <rect
          x={128.14}
          y={266.261}
          width={169.995}
          height={3.036}
          rx={1.518}
          fill="#C7C7C7"
        />
        <rect
          x={128.14}
          y={273.091}
          width={169.995}
          height={3.036}
          rx={1.518}
          fill="#C7C7C7"
        />
        <path
          d="M90.964 84.787a2.833 2.833 0 01-1.519-.414c-.447-.283-.8-.69-1.056-1.223-.256-.533-.384-1.178-.384-1.934s.128-1.401.384-1.934c.257-.532.609-.937 1.056-1.213a2.782 2.782 0 011.52-.425 2.75 2.75 0 011.519.425c.447.276.799.68 1.055 1.213.257.533.385 1.178.385 1.934s-.128 1.4-.385 1.934c-.256.532-.608.94-1.055 1.223-.441.276-.947.414-1.52.414zm0-1.351c.27 0 .504-.076.7-.227.205-.151.362-.392.474-.72.119-.33.178-.754.178-1.273 0-.52-.06-.944-.178-1.273-.112-.329-.27-.569-.473-.72a1.118 1.118 0 00-.7-.227c-.264 0-.497.076-.701.227-.197.151-.355.391-.474.72-.112.33-.167.753-.167 1.273 0 .52.055.944.167 1.273.119.328.277.569.474.72.204.151.437.227.7.227zm3.658-.217v-1.076l3.255-4.38h1.678l-3.187 4.38-.78-.227h5.437v1.303h-6.403zm3.72 1.45v-1.45l.048-1.303v-1.292h1.51v4.045h-1.56z"
          fill="#494947"
        />
        <rect
          x={80}
          y={103.854}
          width={168.477}
          height={3.795}
          rx={1.897}
          fill="#C2C2C2"
        />
        <rect
          x={80}
          y={113.721}
          width={155.575}
          height={3.795}
          rx={1.897}
          fill="#C2C2C2"
        />
        <rect
          x={80}
          y={123.587}
          width={129.014}
          height={3.795}
          rx={1.897}
          fill="#C2C2C2"
        />
        <rect
          x={115.238}
          y={73.499}
          width={137.362}
          height={5.312}
          rx={2.656}
          fill="#8C8C8C"
        />
        <rect
          x={115.238}
          y={82.606}
          width={89.551}
          height={5.312}
          rx={2.656}
          fill="#8C8C8C"
        />
        <path
          d="M42.084 43.225c-.042.127-.084 3.042-.084 6.492v6.281l.83-.084a6.302 6.302 0 003.55-1.62c1-.915 1.464-1.662 1.9-3.028l.31-1.014.015 2.845.014 2.859h6.252l-3.196-3.211-3.197-3.21V43h-3.155c-2.746 0-3.168.028-3.239.225z"
          fill="#9B53C8"
        />
        <path
          d="M51.97 46.154c-1.69 1.718-3.07 3.169-3.07 3.225 0 .07 1.352.127 3 .141l2.985.028.043 3.197.028 3.21h6.407l-3.21-3.21-3.197-3.197 3.168-3.168c1.747-1.746 3.169-3.211 3.169-3.267 0-.07-1.408-.099-3.126-.085l-3.14.014-3.057 3.112z"
          fill="#9B53C8"
        />
        <defs>
          <filter
            id="test-left_svg__a"
            x={78.062}
            y={30.171}
            width={251.877}
            height={271.827}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation={1.247} />
            <feComposite
              in2="SourceAlpha"
              operator="in"
              result="effect1_backgroundBlur_280_2"
            />
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation={12.469} />
            <feColorMatrix values="0 0 0 0 0.420833 0 0 0 0 0.346206 0 0 0 0 0.322639 0 0 0 0.46 0" />
            <feBlend
              in2="effect1_backgroundBlur_280_2"
              result="effect2_dropShadow_280_2"
            />
            <feBlend
              in="SourceGraphic"
              in2="effect2_dropShadow_280_2"
              result="shape"
            />
          </filter>
          <filter
            id="test-left_svg__b"
            x={49.333}
            y={20.751}
            width={269.333}
            height={290.667}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation={1.333} />
            <feComposite
              in2="SourceAlpha"
              operator="in"
              result="effect1_backgroundBlur_280_2"
            />
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation={13.333} />
            <feColorMatrix values="0 0 0 0 0.420833 0 0 0 0 0.346206 0 0 0 0 0.322639 0 0 0 0.46 0" />
            <feBlend
              in2="effect1_backgroundBlur_280_2"
              result="effect2_dropShadow_280_2"
            />
            <feBlend
              in="SourceGraphic"
              in2="effect2_dropShadow_280_2"
              result="shape"
            />
          </filter>
          <filter
            id="test-left_svg__c"
            x={0.644}
            y={0.644}
            width={306.597}
            height={330.882}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation={1.518} />
            <feComposite
              in2="SourceAlpha"
              operator="in"
              result="effect1_backgroundBlur_280_2"
            />
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation={15.178} />
            <feColorMatrix values="0 0 0 0 0.420833 0 0 0 0 0.346206 0 0 0 0 0.322639 0 0 0 0.46 0" />
            <feBlend
              in2="effect1_backgroundBlur_280_2"
              result="effect2_dropShadow_280_2"
            />
            <feBlend
              in="SourceGraphic"
              in2="effect2_dropShadow_280_2"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    );
  }
);
